import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { IoCall } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";
import { MdAttachEmail } from "react-icons/md";
import Card from 'react-bootstrap/Card';
import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
import { FaLocationCrosshairs } from "react-icons/fa6";
import { FaRocketchat } from "react-icons/fa";
import Button from 'react-bootstrap/Button';
import { FaWhatsapp, FaEnvelope, FaPhoneAlt, FaHeadset, FaMapMarkerAlt } from "react-icons/fa";



export default function Contact() {
  return (
    <Container style={{ padding: "40px 20px", minHeight: "calc(100vh - 200px)" }}>
      {/* Header Section */}
      <div className="text-center mb-5">
        <div className="d-flex align-items-center justify-content-center gap-3 mb-3">
          <div
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "16px",
              background: "linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "2px solid #760B0B",
              boxShadow: "0 4px 12px rgba(118, 11, 11, 0.15)",
            }}
          >
            <FaHeadset style={{ fontSize: "28px", color: "#760B0B" }} />
          </div>
          <h2
            className="fw-bold mb-0"
            style={{
              color: "#760B0B",
              fontSize: "36px",
              letterSpacing: "1.5px",
              textShadow: "0 2px 4px rgba(118, 11, 11, 0.1)",
            }}
          >
            CONTACT US
          </h2>
        </div>
        <p className="text-muted" style={{ fontSize: "16px" }}>
          We're here to help! Get in touch with us
        </p>
      </div>

      {/* WhatsApp Button */}
      <div className='text-center mb-5'>
        <Button
          variant="success"
          size='lg'
          className="fw-semibold px-5 py-3 d-inline-flex align-items-center gap-2"
          style={{
            borderRadius: "12px",
            fontSize: "18px",
            transition: "all 0.3s ease",
            boxShadow: "0 4px 15px rgba(40, 167, 69, 0.3)",
            backgroundColor: "#25D366",
            borderColor: "#25D366",
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = "translateY(-3px)";
            e.target.style.boxShadow = "0 6px 20px rgba(37, 211, 102, 0.4)";
            e.target.style.backgroundColor = "#20BA5A";
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "0 4px 15px rgba(40, 167, 69, 0.3)";
            e.target.style.backgroundColor = "#25D366";
          }}
          onClick={() => window.open("https://wa.me/7678134697", "_blank")}
        >
          <FaWhatsapp style={{ fontSize: "24px" }} />
          Chat on WhatsApp
        </Button>
      </div>

      {/* Contact Cards */}
      <Row className="g-4">
        <Col md={4}>
          <Card
            className="border-0 shadow-lg h-100"
            style={{
              borderRadius: "20px",
              border: "2px solid #f0f0f0",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              cursor: "pointer",
              background: "linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-8px)";
              e.currentTarget.style.boxShadow = "0 15px 40px rgba(118, 11, 11, 0.2)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 5px 20px rgba(0,0,0,0.1)";
            }}
          >
            <Card.Body className="p-4 text-center">
              <div
                style={{
                  width: "70px",
                  height: "70px",
                  borderRadius: "16px",
                  background: "linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 18px",
                  border: "2px solid #760B0B",
                  boxShadow: "0 4px 12px rgba(118, 11, 11, 0.15)",
                }}
              >
                <FaEnvelope style={{ fontSize: "32px", color: "#760B0B" }} />
              </div>
              <h4 className='fw-bold mb-2' style={{ color: '#760B0B', fontSize: "20px" }}>Email us</h4>
              <div>
                <a
                  href="mailto:hostelduniya24@gmail.com"
                  className="link-offset-2 link-underline link-underline-opacity-0 fw-semibold"
                  style={{ 
                    color: '#760B0B', 
                    fontSize: "16px",
                    transition: "color 0.3s ease",
                  }}
                  onMouseEnter={(e) => e.target.style.color = "#8B0000"}
                  onMouseLeave={(e) => e.target.style.color = "#760B0B"}
                >
                  hostelduniya24@gmail.com
                </a>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4}>
          <Card
            className="border-0 shadow-lg h-100"
            style={{
              borderRadius: "20px",
              border: "2px solid #f0f0f0",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              cursor: "pointer",
              background: "linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-8px)";
              e.currentTarget.style.boxShadow = "0 15px 40px rgba(118, 11, 11, 0.2)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 5px 20px rgba(0,0,0,0.1)";
            }}
          >
            <Card.Body className="p-4 text-center">
              <div
                style={{
                  width: "70px",
                  height: "70px",
                  borderRadius: "16px",
                  background: "linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 18px",
                  border: "2px solid #760B0B",
                  boxShadow: "0 4px 12px rgba(118, 11, 11, 0.15)",
                }}
              >
                <FaPhoneAlt style={{ fontSize: "32px", color: "#760B0B" }} />
              </div>
              <h4 className='fw-bold mb-2' style={{ color: '#760B0B', fontSize: "20px" }}>Call us</h4>
              <div className='text-center'>
                <a
                  href="tel:7678134697"
                  className='link-offset-2 link-underline link-underline-opacity-0 fw-semibold'
                  style={{ 
                    color: '#760B0B', 
                    fontSize: "18px",
                    transition: "color 0.3s ease",
                  }}
                  onMouseEnter={(e) => e.target.style.color = "#8B0000"}
                  onMouseLeave={(e) => e.target.style.color = "#760B0B"}
                >
                  +91 7678134697
                </a>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4}>
          <Card
            className="border-0 shadow-lg h-100"
            style={{
              borderRadius: "20px",
              border: "2px solid #f0f0f0",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              cursor: "pointer",
              background: "linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-8px)";
              e.currentTarget.style.boxShadow = "0 15px 40px rgba(118, 11, 11, 0.2)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 5px 20px rgba(0,0,0,0.1)";
            }}
          >
            <Card.Body className="p-4 text-center">
              <div
                style={{
                  width: "70px",
                  height: "70px",
                  borderRadius: "16px",
                  background: "linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 18px",
                  border: "2px solid #760B0B",
                  boxShadow: "0 4px 12px rgba(118, 11, 11, 0.15)",
                }}
              >
                <FaMapMarkerAlt style={{ fontSize: "32px", color: "#760B0B" }} />
              </div>
              <h4 className='fw-bold mb-2' style={{ color: '#760B0B', fontSize: "20px" }}>Address</h4>
              <div className='text-center'>
                <p className='mb-0 fw-semibold' style={{ color: '#760B0B', fontSize: "16px", lineHeight: "1.6" }}>
                  B-116 Rajiv Nagar<br />Budh Bazar
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}
